import { Breadcrumbs } from "@mui/material";
import Divider from "@mui/material/Divider";
import { BreadCrumb } from "../BreadCrumb";

export default function UploadBreadCrumbs({ active, onSelected }) {
  const handleClick = (n) => {
    if (onSelected) onSelected(n);
  };
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<Divider sx={{ background: "#BDBDBD", width: 36 }} />}
    >
      <BreadCrumb
        onClick={handleClick}
        active={active}
        number={1}
        label="Import, Split and Convert"
      />
      <BreadCrumb
        onClick={handleClick}
        active={active}
        number={2}
        label="Normalize"
      />
    </Breadcrumbs>
  );
}
